import { render, staticRenderFns } from "./swiperList.vue?vue&type=template&id=bc6798f8&scoped=true"
import script from "./swiperList.vue?vue&type=script&lang=js"
export * from "./swiperList.vue?vue&type=script&lang=js"
import style0 from "./swiperList.vue?vue&type=style&index=0&id=bc6798f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6798f8",
  null
  
)

export default component.exports